// extracted by mini-css-extract-plugin
module.exports = {"text":"ClickToCopy_text__pBTEA","message":"ClickToCopy_message__3g8xZ","off":"ClickToCopy_off__1VRaT","on":"ClickToCopy_on__2gLGr"};